/**
 * Transforms a Number into a String with the given number of decimals and a comma as decimal separator.
 * @param {Number} val - The value to be formatted.
 * @returns {String} The formatted value.
 * @example price(1234.5678) // => '€ 1.234,57'
 * @example price("1234.56") // => '€ 1.234,56'
 * @example price("banana") // => 'banana'
 */
export const price = (val) => {
    // Try to parse the value to a number. This is needed because the value can be a string.
    const valFloat = parseFloat(val);

    // If the value is not a number, return the original value.
    if (isNaN(valFloat)) {
        return val;
    }

    // Return the value formatted as a currency.
    return (new Intl.NumberFormat('nl-NL', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'EUR',
    })).format(valFloat)
};

export default { price };